import { useMutation, useQueryClient } from "@tanstack/react-query";
import { unlockAllLogins } from "@/api/monitor";
import { MonitorQueryKeys } from "@/tanstackQuery/queries/monitor";

export const useUnlockAllLogins = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unlockAllLogins,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MonitorQueryKeys.LoginSecurity],
      });
    },
  });
};
